import React, { useState } from 'react';
import { followUpChipClass } from './chatViewTheme';
import { inputCompact, button } from '../ui/uiTheme';

export default function VantiQuestion({ question, onAnswer, disabled }: any) {
  const [selected, setSelected] = useState<any>(null);
  const [custom, setCustom] = useState('');
  const [answered, setAnswered] = useState(false);

  const submit = (value) => {
    if (answered || disabled) return;
    setAnswered(true);
    onAnswer(value);
  };

  if (answered) {
    return (
      <div className="mt-2 rounded-xl border border-brand-purple/30 bg-brand-purple/10 px-3 py-2 text-xs text-brand-purple-light">
        ✓ {selected || custom}
      </div>
    );
  }

  return (
    <div className="mt-3 rounded-xl border border-dark-border bg-dark-elevated p-3">
      <p className="mb-2.5 text-sm font-medium text-slate-100">{question.question}</p>
      <div className="flex flex-wrap gap-2">
        {(question.options || []).map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => {
              setSelected(opt.label);
              submit(opt.label);
            }}
            className={`${followUpChipClass} ${
              selected === opt.label ? 'border-brand-purple bg-brand-purple/20 text-white' : ''
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {question.allowCustom && (
        <div className="mt-2 flex gap-2">
          <input
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && custom.trim() && submit(custom.trim())}
            placeholder={question.customPlaceholder || 'Type your own answer…'}
            className={`${inputCompact} flex-1 py-1.5 text-xs`}
          />
          <button
            type="button"
            disabled={!custom.trim()}
            onClick={() => submit(custom.trim())}
            className={`${button.primarySm} disabled:opacity-40`}
          >
            Submit
          </button>
        </div>
      )}
    </div>
  );
}
